import { IMemberProps } from 'common/interface/props';

//UI Components
import Grid from 'components/UI/atoms/Grid';
import Banner from 'components/UI/molecules/Banner';
import LoginForm from 'components/UI/organisms/LoginForm';
import LoginGuide from 'components/UI/organisms/LoginGuide';
import Container from 'components/UI/atoms/Container';

export default function Login({ solType }: IMemberProps) {
  return (
    <>
      <Banner imgPath="/images/bg_login.png" text="플레이오토 로그인" />
      <Container noBody={true}>
        <Grid top={30} bottom={30}>
          <LoginGuide />
        </Grid>
        <Grid bottom={50}>
          <LoginForm solType={solType} />
        </Grid>
      </Container>
    </>
  );
}
